import { routerMiddleware } from 'connected-react-router';
import history from '../index';

export default routerMiddleware(history)
